/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmProjectBillingData
 */
export interface CrmProjectBillingData {
    /**
     * 
     * @type {string}
     * @memberof CrmProjectBillingData
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectBillingData
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectBillingData
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectBillingData
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectBillingData
     */
    zip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectBillingData
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectBillingData
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectBillingData
     */
    companyRegistrationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectBillingData
     */
    vatNumber?: string | null;
}

/**
 * Check if a given object implements the CrmProjectBillingData interface.
 */
export function instanceOfCrmProjectBillingData(value: object): value is CrmProjectBillingData {
    return true;
}

export function CrmProjectBillingDataFromJSON(json: any): CrmProjectBillingData {
    return CrmProjectBillingDataFromJSONTyped(json, false);
}

export function CrmProjectBillingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectBillingData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'companyName': json['companyName'] === undefined ? undefined : json['companyName'] === null ? null : json['companyName'],
        'street': json['street'] === undefined ? undefined : json['street'] === null ? null : json['street'],
        'city': json['city'] === undefined ? undefined : json['city'] === null ? null : json['city'],
        'zip': json['zip'] === undefined ? undefined : json['zip'] === null ? null : json['zip'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'countryCode': json['countryCode'] === undefined ? undefined : json['countryCode'] === null ? null : json['countryCode'],
        'companyRegistrationNumber': json['companyRegistrationNumber'] === undefined ? undefined : json['companyRegistrationNumber'] === null ? null : json['companyRegistrationNumber'],
        'vatNumber': json['vatNumber'] === undefined ? undefined : json['vatNumber'] === null ? null : json['vatNumber'],
    };
}

export function CrmProjectBillingDataToJSON(json: any): CrmProjectBillingData {
    return CrmProjectBillingDataToJSONTyped(json, false);
}

export function CrmProjectBillingDataToJSONTyped(value?: CrmProjectBillingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyName': value['companyName'],
        'street': value['street'],
        'city': value['city'],
        'zip': value['zip'],
        'email': value['email'],
        'countryCode': value['countryCode'],
        'companyRegistrationNumber': value['companyRegistrationNumber'],
        'vatNumber': value['vatNumber'],
    };
}

